import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import BgFrame from "../../../Components/Common/BgFrame";
import MobileViewContainer from "../../../Components/MobileViewContainer";
import { CheckoutHeader } from "../components";
import OrderProcess from "./OrderProcess";

const OrderPage = () => {
  const navigate = useNavigate();
  const [checkoutProgressPercent, setCheckoutProgressPercent] = useState(100);

  return (
    <MobileViewContainer>
      <CheckoutHeader title="예약 결제" onBack={() => navigate(-1)} progressPercent={checkoutProgressPercent} />
      <BgFrame>
        <OrderProcess onProgressChange={setCheckoutProgressPercent} />
      </BgFrame>
    </MobileViewContainer>
  );
};

export default OrderPage;
